import { defaultBalancesTabs } from '../../../Blotters/BalancesV2/defaults';
import type { BalancesV2TabProps } from '../../../Blotters/BalancesV2/types';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile balances content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileBalancesBlotter(props: Omit<MobileBlotterPanelProps<BalancesV2TabProps>, 'defaultTabs'>) {
  return <MobileBlotterPanel<BalancesV2TabProps> {...props} defaultTabs={defaultBalancesTabs} />;
}
